export default __webpack_public_path__ + "static/classyessaywriter-dcd61bdc2be4d200fd882ffb756fc243.webp";